<template>
    <div class="card">
        <div class="card__patch">
            <img :src="launch.links.mission_patch_small" alt="">
        </div><!-- /.card__patch -->
        <div class="card__content">
            <router-link tag="h2" :to="{name: 'launch', params: { id: launch.flight_number, launch: launch }}" class="card__title">
                {{launch.mission_name}}
            </router-link><!-- /.card__title -->
            <router-view/>
            <p class="card__desc">{{launch.details ? launch.details.substring(0, 120) : 'There are no details provided from SpaceX for this launch'}}</p><!-- /.card__desc -->
            <div class="card__icons">
                <div class="card__icon">
                    <img src="../assets/spaceship.svg" alt="">
                    <span class="card__icon-text">
                        <router-link :to="{name: 'rocket', params: { id: launch.rocket.rocket_id}}" class="card__icon-text">
                            {{launch.rocket.rocket_name}}
                        </router-link><!-- /.card__title -->
                    </span><!-- /.card__icon-text -->
                </div><!-- /.card__icon -->
                <div class="card__icon">
                    <img src="../assets/box.svg" alt="">
                    <span class="card__icon-text">{{launch.rocket.second_stage.payloads[0].payload_type}}</span><!-- /.card__icon-text -->
                </div><!-- /.card__icon -->
                <div class="card__icon card__icon--last">
                    <img src="../assets/calendar.svg" alt="">
                    <span class="card__icon-text">{{convertTimestamp(launch.launch_date_unix)}}</span><!-- /.card__icon-text -->
                </div><!-- /.card__icon -->
            </div><!-- /.card__icons -->
        </div><!-- /.card__content -->
        <span class="card__badge" :class=" launch.launch_success ? '' : 'card__badge--failed'">{{launch.launch_success ? 'Success' : 'Failed'}}</span><!-- /.card__badge -->
    </div><!-- /.card -->
</template>

<script>
export default {
    name: 'Card',
    props: {
        launch: Object
    },
    data() {
        return {

        }
    },
    methods: {
        convertTimestamp(timestamp) {
            parseInt(timestamp);
            var d = new Date(timestamp * 1000),	// Convert the passed timestamp to milliseconds
            yyyy = d.getFullYear(),
            mm = ('0' + (d.getMonth() + 1)).slice(-2),	// Months are zero based. Add leading 0.
            dd = ('0' + d.getDate()).slice(-2),			// Add leading 0.
            hh = d.getHours(),
            h = hh,
            min = ('0' + d.getMinutes()).slice(-2),		// Add leading 0.
            ampm = 'AM',
            time;
                    
            if (hh > 12) {
                h = hh - 12;
                ampm = 'PM';
            } else if (hh === 12) {
                h = 12;
                ampm = 'PM';
            } else if (hh == 0) {
                h = 12;
            }
            
            // ie: 2013-02-18, 8:35 AM	
            time = dd + '/' + mm + '/' + yyyy + ', ' + h + ':' + min + ' ' + ampm;
                
            return time;
        }
    }
}
</script>
